// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"04b1e02f","787":"e73cbbe0","861":"60bab44c"}[chunkId] + ".chunk.js";
};